export * from '@primeuix/themes/material/tag';
export { default } from '@primeuix/themes/material/tag';
